// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"352":"lang-vi-setting","729":"lang-en-US-setting","782":"lang-en-US","899":"lang-vi"}[chunkId] || chunkId) + "." + {"352":"23ab0aa1","505":"7aff0aaa","690":"2488b7f3","729":"ad4b0824","782":"9a8f21a6","899":"dff1d3f5"}[chunkId] + ".js";
};